/**
 * AI Agent API Client — calls ZentroBooks AI endpoints.
 * All AI logic lives on the server; this is a thin client.
 */

import { apiRequest } from "@/lib/queryClient";

// ─── Workflows ──────────────────────────────────────────────────────

export async function runWorkflow(workflow: string, startDate: string, endDate: string, businessId?: number) {
  const res = await apiRequest("POST", "/api/ai-agent/workflow", { workflow, start_date: startDate, end_date: endDate });
  return res.json();
}

export async function getWorkflow(id: number) {
  const res = await apiRequest("GET", `/api/ai-agent/workflow/${id}`);
  return res.json();
}

export async function resumeWorkflow(id: number) {
  const res = await apiRequest("POST", `/api/ai-agent/workflow/${id}/resume`);
  return res.json();
}

export async function listWorkflows(businessId?: number) {
  const res = await apiRequest("GET", "/api/ai-agent/workflows");
  return res.json();
}

// ─── Analysis ───────────────────────────────────────────────────────

export async function analyzeFinancials(startDate: string, endDate: string, businessId?: number) {
  const res = await apiRequest("POST", "/api/ai-agent/run", { command: "analyze financials", start_date: startDate, end_date: endDate });
  return res.json();
}

// ─── Action Queue ───────────────────────────────────────────────────

export async function getQueue(businessId?: number, status?: string) {
  let url = "/api/ai-agent/queue";
  const params = new URLSearchParams();
  if (status) params.set("status", status);
  if (params.toString()) url += `?${params}`;
  const res = await apiRequest("GET", url);
  return res.json();
}

export async function approveAction(id: number) {
  const res = await apiRequest("POST", `/api/ai-agent/approve/${id}`);
  return res.json();
}

export async function rejectAction(id: number, reason?: string) {
  const res = await apiRequest("POST", `/api/ai-agent/reject/${id}`, { reason });
  return res.json();
}
